define('form/file',['jquery', 'source/sourcecompleter', 'form/upload/uploader', 'utils/common', 'form/selector'], function ($, SourceCompleter, Uploader) {
	
	var File = function (settings) {
		var $this = this;
		this.settings = $.extend({
			widget : null,
		
			data : {
				token : $('meta[name=csrf]').attr("content")
			},
			
			manageRights : true,
			
			enableUpload : false,
			
			script : null
		}, settings);
		
		this.id = function () {
			return this.settings.widget.attr('data-id');
		};
		
		this.processRights = function () {
			
			var rights = this.serializeRights();
				
			var checked_list = [];
			this.settings.widget.find('ul input:checked').each(function () {
				var input = $(this);
				checked_list.push($(this).val());
			});
			
			if(checked_list.length > 0) {
				this.settings.widget.find('ul').addClass('waiting');
				$.post($.url('/file/update', { p : $this.id() }), {ids : checked_list, item_rights : rights}, function (d) {
					$.each(d, function () {
						var new_li = $.render('file_item', this);
						$this.settings.widget.find('ul li[data-id="'+this.id+'"]').replaceWith(new_li);
					});
					
					$this.settings.widget.find('ul').removeClass('waiting');
				});
			}
		};
		
		this.add = function (json) {
			
			var li = $.render('file_item', json);
			this.settings.widget.find('ul').append(li);
			
			li = this.settings.widget.find('ul li[data-id="'+json.id+'"]');
			if(!this.settings.manageRights) {
				li.find('input').remove();
			}
			
			// after adding visible!
			if(this.settings.manageRights) {
				this.settings.widget.find('.rights').css('display', 'block');
			}
		};
		
		this.serializeRights = function () {
			var ids = [];
			this.settings.widget.find('input[type="hidden"]').each(function () {
				ids.push($(this).val());
			});
			
			return ids;
		};
		
		this.load = function () {
			var parent_id = $this.id();
			
			if(!$.isNothing(parent_id)) {
				$.get($.url('/file/list', {id : parent_id }), function (d) {
					$.each(d, function () {
						$this.add(this);
					});
				});
			}
		};
		
		this.init = function () {
			//Maak filewidget beschikbaar van buitenaf
			this.settings.widget.data('widget', this);
			
			this.settings.widget.find('.rights').css('display', 'none');
			
			this.settings.widget.find('ul').on('click', 'a.delete', function (event) {
				event.preventDefault();
				
				var a = $(this);
				
				var item_id = a.closest('li').data('id');
				
				if(a.closest('li').data('type') == 'image') {
					var url = $.url('/image/delete', {id : item_id });
				} else {
					var url = $.url('/file/delete', {id : item_id });
				}
				
				$.post(url, function (data) {
					a.closest('li[data-id='+item_id+']').remove();
				});
				
				return false;
			});
			
			if(this.settings.manageRights) {
				this.settings.widget.find('.multiselect input').formSelector({
					focus: true,
					multiSelect: true,
					onlyExists: true,
					source : new SourceCompleter({
						url : '/info/getgroups',
						name : 'rights',
						formatter : function (item, term) {
							var name = item.name.replace(new RegExp(term, 'i'), '<span class="marked">'+term+'</span>'); 
							return $('<li><a href="#">' + name + '</a></li>');
						},
						selector : $this.settings.widget.find('.multiselect'),
						onAdd : function(data) {
							
							$(this.options.selector).after($('<input type="hidden" name="'+this.options.name+'[file][]" value="'+data.id+'">'));
							
							$this.processRights();
						}
					})
				});
			}
			
			if(this.settings.enableUpload) {
				
				var context = this.settings.widget.find('.uploadarea');
				context.css('display', 'block');
				new Uploader(context.find('.droparea'), {
					
					progressArea : context.find('.progressarea'),
					
					showProgress : true,
					onlyProgress : true,
					
					data : $.extend(this.settings.data, { 
						session: this.settings.widget.data('session'),
					}),
					
					script : $.url(this.settings.script!=null?this.settings.script:'/file/upload', {id : $this.id(), key : this.settings.widget.data('key') }),
					
					onComplete : function (fileObj, result) {
						$this.add(result.data !== undefined ? result.data : result);
					}
				});	  
			}
			
			this.load();
		};

		this.init();
	};
	
	
	return File;
	
});
